// have to simulate click because Safari Mobile
export const simulateClick = function (elem: {
  dispatchEvent: (arg0: MouseEvent) => any;
}) {
  try {
    // Create our event (with options)
    const evt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    // If cancelled, don't dispatch our event
    !elem.dispatchEvent(evt);
  } catch (error) {
    throw error;
  }
};
